import { render, staticRenderFns } from "./GrantSubWizard.vue?vue&type=template&id=5a6b5767&scoped=true&"
import script from "./GrantSubWizard.vue?vue&type=script&lang=js&"
export * from "./GrantSubWizard.vue?vue&type=script&lang=js&"
import style0 from "./GrantSubWizard.vue?vue&type=style&index=0&id=5a6b5767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b5767",
  null
  
)

export default component.exports